import { render, staticRenderFns } from "./JobOfferSettingsPage.vue?vue&type=template&id=bff105b2&scoped=true&"
import script from "./JobOfferSettingsPage.vue?vue&type=script&lang=js&"
export * from "./JobOfferSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./JobOfferSettingsPage.vue?vue&type=style&index=0&id=bff105b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff105b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bff105b2')) {
      api.createRecord('bff105b2', component.options)
    } else {
      api.reload('bff105b2', component.options)
    }
    module.hot.accept("./JobOfferSettingsPage.vue?vue&type=template&id=bff105b2&scoped=true&", function () {
      api.rerender('bff105b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/JobOffers/JobOfferSettingsPage.vue"
export default component.exports